export default __webpack_public_path__ + "static/media/bookshelf-full.06f94200.png";